import { type RouteRecordRaw } from 'vue-router'

import { applyMetaToChildren } from '@/utils/router'

export const seoRouter: RouteRecordRaw[] = [
  {
    children: applyMetaToChildren(
      [
        {
          component: async () => import('../views/RedirectsView.vue'),
          meta: {
            title: 'seo.redirects',
          },
          name: 'seo.redirects',
          path: 'redirects',
        },
      ],
      {
        roles: ['pb:*'],
      }
    ),
    component: {
      name: 'SEOView',
      template: '<router-view />',
    },
    path: 'seo',
    redirect: { name: 'seo.redirects' },
  },
]
